import { render } from "./GameSetupDetail.vue?vue&type=template&id=422edf3a&ts=true"
import script from "./GameSetupDetail.vue?vue&type=script&lang=ts"
export * from "./GameSetupDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__